import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

type MetricTone = "default" | "good" | "warn" | "bad";

type MetricCardProps = {
  label: string;
  value: string;
  detail?: string;
  tone?: MetricTone;
};

const toneClasses: Record<MetricTone, string> = {
  default: "border-[#20304a] bg-[#071120]",
  good: "border-[#20304a] bg-[#071120]",
  warn: "border-[#20304a] bg-[#071120]",
  bad: "border-[#20304a] bg-[#071120]",
};

const valueClasses: Record<MetricTone, string> = {
  default: "text-white",
  good: "text-white",
  warn: "text-[#ff4a25]",
  bad: "text-[#ff4a25]",
};

const detailClasses: Record<MetricTone, string> = {
  default: "text-[#8490a3]",
  good: "text-[#28f06a]",
  warn: "text-[#ff4a25]",
  bad: "text-[#ff4a25]",
};

export function MetricCard({
  label,
  value,
  detail,
  tone = "default",
}: MetricCardProps): JSX.Element {
  return (
    <Card
      className={cn(
        "min-h-[94px] justify-between gap-2 rounded-lg p-4 shadow-[inset_0_1px_0_rgba(255,255,255,0.03)] transition-colors",
        toneClasses[tone],
      )}
      size="sm"
    >
      <span className="text-[13px] font-medium text-[#a4acb9]">
        {label}
      </span>
      <strong className={cn("whitespace-nowrap text-[22px] font-extrabold leading-none tabular-nums", valueClasses[tone])}>
        {value}
      </strong>
      {detail ? (
        <span className={cn("text-xs font-bold", detailClasses[tone])}>{detail}</span>
      ) : null}
    </Card>
  );
}
